const DEFERRED = "deferred_to_later_turn";
const ACTION_START =
  /^(checking|preparing|reviewing|finding|creating|loading|reading|writing|searching|waiting)\b/i;

function lowerLead(value) {
  return value ? value[0].toLowerCase() + value.slice(1) : value;
}

function complete(value) {
  return /[.!…]$/.test(value) ? value : `${value}.`;
}

function progress(detail, title) {
  if (!detail) return `I’m working on this step: ${complete(title)}`;
  if (/^i(?:’m| am)\b/i.test(detail)) return complete(detail);
  return ACTION_START.test(detail)
    ? `I’m ${complete(lowerLead(detail))}`
    : complete(detail);
}

export function taskNarrationCopy(task = {}) {
  if (task.status === "failed") {
    return task.blocker
      ? `This step needs attention: ${complete(task.blocker)}`
      : "This step could not be completed.";
  }
  if (task.status === "waiting") {
    if (task.wait_reason === "approval")
      return "Waiting for your approval before this can continue.";
    if (task.wait_reason === "user_input")
      return "Waiting for the information I need from you before I continue.";
    return task.detail
      ? complete(task.detail)
      : "Waiting before this step can continue.";
  }
  if (task.status === "completed") {
    return task.authority === "server"
      ? "The connected service confirmed this step."
      : "The agent marked this step complete.";
  }
  if (task.status === "skipped") return "This step was skipped.";
  if (task.settle_reason === DEFERRED)
    return "This step will continue when you send your next message.";
  if (task.status === "in_progress")
    return progress(task.detail, task.title ?? "the requested work");
  if (task.next_action)
    return `Next, I’ll ${complete(lowerLead(task.next_action))}`;
  return `Next, I’ll work on this step: ${complete(task.title ?? "the requested work")}`;
}
